window.DealSkus = {
    init(dealUuid) {
        this.fetchSkus(dealUuid);
        this.handleSkuUpdate();
        this.handleSkuAdd(dealUuid);
        this.handleSkuDelete();
        this.handleSkuCreate(dealUuid);
    },

    fetchSkus(dealUuid) {
        const url = `/deals/${dealUuid}/deal_skus`;

        fetch(url)
            .then(response => response.json())
            .then(data => {
                this.renderSkus(data);
            })
            .catch(error => console.error('Error fetching SKUs:', error));
    },

    updateSku(skuId, description) {
        const url = `/deal_skus/${skuId}`;
        const data = { deal_sku: { description: description } };

        fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            this.renderSkus(data);
        })
        .catch(error => console.error('Error updating SKU:', error));

    },

    renderSkus(data) {
        document.querySelectorAll('#skus-container').forEach(container => {
            container.innerHTML = '';
            data.forEach(sku => {
                container.appendChild(this.createSkuElement(sku));
            });
        });
    },

    createSkuElement(sku) {
        const skuElement = document.createElement('div');
        skuElement.className = 'sku';

        const skuRow = document.createElement('div');
        skuRow.className = 'row';

        const skuCol1 = document.createElement('div');
        skuCol1.className = 'col';

        const descriptionLabel = document.createElement('label');
        descriptionLabel.className = 'col';
        descriptionLabel.textContent = 'Description';

        const descriptionInput = document.createElement('input');
        descriptionInput.type = 'text';
        descriptionInput.value = sku.description;
        descriptionInput.dataset.id = sku.id;
        descriptionInput.className = 'form-control sku-description';

        skuCol1.appendChild(descriptionLabel);
        skuCol1.appendChild(descriptionInput);

        const skuCol2 = document.createElement('div');
        skuCol2.className = 'col';

        const tagsLabel = document.createElement('label');
        tagsLabel.className = 'col';
        tagsLabel.textContent = 'Tags';

        const tagsInput = document.createElement('textarea');
        tagsInput.type = 'text';
        tagsInput.value = sku.tags;
        tagsInput.dataset.id = sku.id;
        tagsInput.className = 'form-control sku-tags';
        tagsInput.readOnly = true;

        skuCol2.appendChild(tagsLabel);
        skuCol2.appendChild(tagsInput);

        const skuCol3 = document.createElement('div');
        skuCol3.className = 'col';

        const categoriesLabel = document.createElement('label');
        categoriesLabel.className = 'col';
        categoriesLabel.textContent = 'Categories';

        const categoriesInput = document.createElement('input');
        categoriesInput.type = 'text';
        categoriesInput.value = sku.categories;
        categoriesInput.dataset.id = sku.id;
        categoriesInput.className = 'form-control sku-categories disabled';

        skuCol3.appendChild(categoriesLabel);
        skuCol3.appendChild(categoriesInput);

        const skuCol4 = document.createElement('div');
        skuCol4.className = 'col align-self-end';

        const updateButton = document.createElement('button');
        updateButton.type = 'button';
        updateButton.className = 'btn btn-outline-primary update-sku';
        updateButton.dataset.id = sku.id;
        updateButton.textContent = 'Update';

        const deleteButton = document.createElement('button');
        deleteButton.type = 'button';
        deleteButton.className = 'btn btn-outline-secondary delete-sku';
        deleteButton.dataset.id = sku.id;
        deleteButton.textContent = 'Delete';

        const createButton = document.createElement('button');
        createButton.type = 'button';
        createButton.className = 'btn btn-outline-primary create-sku';
        createButton.dataset.dealUuid = sku.dealUuid;
        createButton.textContent = 'Create';

        if (sku.id) {
            skuCol4.appendChild(updateButton);
            skuCol4.appendChild(deleteButton);
        } else {
            skuCol4.appendChild(createButton);
        }

        skuRow.appendChild(skuCol1);
        skuRow.appendChild(skuCol2);
        skuRow.appendChild(skuCol3);
        skuRow.appendChild(skuCol4);

        skuElement.appendChild(skuRow);
        return skuElement;
    },

    handleSkuUpdate() {
        document.querySelectorAll('#skus-container').forEach(container => {
            container.addEventListener('click', (event) => {
                if (event.target.classList.contains('update-sku')) {
                    if(event.target.dataset.id === "undefined" || event.target.dataset.id === "") {
                        // event could be firing for a create rather than an update form
                        return;
                    }
                    const skuId = event.target.dataset.id;
                    const formRow = event.target.closest('.row');
                    const description = formRow.querySelector('.sku-description').value;
                    this.updateSku(skuId, description);
                }
            });
        });
    },

    handleSkuDelete() {
        document.querySelectorAll('#skus-container').forEach(container => {
            container.addEventListener('click', (event) => {
                if (event.target.classList.contains('delete-sku')) {
                    const skuId = event.target.dataset.id;
                    this.deleteSku(skuId);
                }
            });
        });
    },

    deleteSku(skuId) {
        const url = `/deal_skus/${skuId}`;

        fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
        .then(response => response.json())
        .then(data => {
            this.renderSkus(data);
        })
        .catch(error => console.error('Error deleting SKU:', error));
    },

    handleSkuAdd(dealUuid) {
        document.querySelectorAll('#add-sku-button').forEach(btn => {
            btn.addEventListener('click', () => {
                let sku = { dealUuid: dealUuid, description: "" };
                document.querySelectorAll('#skus-container').forEach(container => {
                    container.appendChild(this.createSkuElement(sku));
                });
            });
        });
    },

    handleSkuCreate(dealUuid) {
        document.querySelectorAll('#skus-container').forEach(container => {
            container.addEventListener('click', (event) => {
                if (event.target.classList.contains('create-sku')) {
                    const dealUuid = event.target.dataset.dealUuid;
                    const formRow = event.target.closest('.row');
                    const sku = {
                        description: formRow.querySelector('.sku-description').value
                    };
                    this.createSku(dealUuid, sku);
                }
            });
        });
    },

    createSku(dealUuid, dealSku){
        const url = `/deals/${dealUuid}/deal_skus`;
        const data = { deal_sku: dealSku };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            this.renderSkus(data);
        })
        .catch(error => console.error('Error creating SKU:', error));
    }
}
